import * as React from 'react';
// import ViewSummary from './View-summary';
import TimeTableJoinNow from './Time-table-join-now';
import TimeTableEvents from './Time-table-events';
import Upcoming from './Upcoming';
import { Tooltip } from "@mui/material";
import { shortenParagraph } from '../../../utils/Engagement';

const TimeTableDayEvent = ({ event, summaryShowToday, handleId, open }) => {
    const currentTime = new Date();
    const eventStartTime = new Date(event?.StartTime);
    const eventEndTime = new Date(event?.EndTime);

    const isHappened = currentTime.getTime() > eventEndTime.getTime();
    const isEventHappening = currentTime.getTime() >= eventStartTime.getTime() && currentTime.getTime() <= eventEndTime.getTime();
    const isUpcoming = currentTime.getTime() < eventStartTime.getTime() && !isEventHappening;

    const onJoinNowClick = (e) => {
        e.preventDefault();
        //allow to show weekday popup
        // e.stopPropagation();
    };

    const handleTimeDifference = (start, end) => {
        const startTime = new Date(start);
        const endTime = new Date(end);
        const differenceInMilliseconds = endTime - startTime;
        const differenceInMinutes = Math.floor(
            differenceInMilliseconds / (1000 * 60)
        );
        return differenceInMinutes;
    };


    return (
        //Here Added logic for Assemble and their background color
        <div onClick={onJoinNowClick} className="template-wrap" >
            <div className='container' style={{ marginTop: "5px" }}>
                <div className="row">
                    <div className="LiveSession col-lg-2">
                        {(event.lectureType !== "general_category" && event.Events[0] !== "Planner") && <p>Lecture Session</p>}
                        {((event.Events[0] === "Planner" && !isHappened && event.lectureType !== "general_category")) && <p className='stp2'>Study Planner</p>}
                        {((event.Events[0] === "Planner" && isHappened && event.lectureType !== "general_category")) && <p className='stp1'>Study Planner</p>}
                    </div>
                    {event.lectureType === "general_category" && event.Events[0] !== "Planner" ? (
                        <div className="weekStyleDay" style={{ padding: "0px", letterSpacing: "1.2em" }}>
                            {event.lectureName.toUpperCase()}
                        </div>
                    ) : null}
                    {/* {isHappened && event.Events[0] === "Planner" && (
                        <div className="subjectNm2">
                            <Tooltip
                                title={event.Subject}
                                arrow
                                placement="bottom"
                                enterDelay={200}
                                leaveDelay={100}
                            >
                                <span className="sbj">
                                    {shortenParagraph(event.Subject, 15)}
                                </span>
                            </Tooltip>

                        </div>
                    )} */}
                    <div className="col-2">
                        {event.lectureType !== "general_category" && (event.Events[0] === "Planner" && isHappened) && (
                            <div className="subjectNm2">
                                <Tooltip
                                    title={event.Subject}
                                    arrow
                                    placement="top"
                                    enterDelay={200}
                                    leaveDelay={100}
                                >
                                    <span className="sbj">
                                        {shortenParagraph(event.Subject, 25)}
                                    </span>
                                </Tooltip>
                            </div>
                        )}
                        {event.lectureType !== "general_category" && (event.Events[0] === "Planner" && !isHappened) && (
                            <div className="subjectNm1">
                                <Tooltip
                                    title={event.Subject}
                                    arrow
                                    placement="top"
                                    enterDelay={200}
                                    leaveDelay={100}
                                >
                                    <span className="sbj">
                                        {shortenParagraph(event.Subject, 25)}
                                    </span>
                                </Tooltip>
                            </div>
                        )}
                        {event.lectureType !== "general_category" && event.Events[0] !== "Planner" ? (
                            <Tooltip
                                title={event.Subject}
                                arrow
                                placement="bottom"
                                enterDelay={200}
                                leaveDelay={100}
                            >
                                <span className="sbj">
                                    {shortenParagraph(event.Subject, 20)}
                                </span>
                            </Tooltip>
                        ) : null}
                    </div>
                    <TimeTableEvents event={event} />

                    {(event.lectureType !== "general_category" && (event.Events[0] === "Planner" && !isHappened)) && <div className='col-1'>
                        <p className='StdDesc1'>
                            <Tooltip
                                title={event?.name}
                                arrow
                                placement="bottom"
                                enterDelay={200}
                                leaveDelay={100}
                            >
                                <span className="sbj">
                                    {event?.name}
                                </span>
                            </Tooltip>

                        </p>
                    </div>}
                    {(event.lectureType !== "general_category" && (event.Events[0] === "Planner" && isHappened)) && <div className='col-1'>
                        <p className='StdDesc2'>
                            <Tooltip
                                title={event?.name}
                                arrow
                                placement="bottom"
                                enterDelay={200}
                                leaveDelay={100}
                            >
                                <span className="sbj">
                                    {event?.name}
                                </span>
                            </Tooltip>
                        </p>
                    </div>}
                    <div className="col-2">
                        <Tooltip
                            title={event?.Teacher?.name}
                            arrow
                            placement="bottom"
                            enterDelay={200}
                            leaveDelay={100}
                        >
                            <span className='subjectNm'>{shortenParagraph(event?.Teacher?.name ? event?.Teacher?.name : "", 20)}</span>
                        </Tooltip>
                    </div>
                    {(event.lectureType !== "general_category" && event.Events[0] !== "Planner") && <div className="col-1">
                        <p className="timeDiff">
                            {handleTimeDifference(event.StartTime, event.EndTime)} mins
                        </p>
                    </div>}
                    {(event.lectureType !== "general_category" && (event.Events[0] === "Planner" && !isHappened)) && <div className="col-1">
                        <p className="timeDiff1">
                            {handleTimeDifference(event.StartTime, event.EndTime)} mins
                        </p>
                    </div>}
                    {(event.lectureType !== "general_category" && (event.Events[0] === "Planner" && isHappened)) && <div className="col-2">
                        <p className="timeDiff2">
                            {handleTimeDifference(event.StartTime, event.EndTime)} mins
                        </p>
                    </div>}
                    <div className="col-2">
                        {(event.Events[0] !== "Planner" && event.lectureType !== "general_category") && isHappened && event.SupplementId !== undefined ? (
                            <div
                                style={{ cursor: "pointer", textAlign: "center" }}
                                onClick={() => {
                                    summaryShowToday();
                                    handleId(event);
                                }}
                            >
                                View Summary
                            </div>
                        ) : ""}
                        {(event.Events[0] !== "Planner" && event.lectureType !== "general_category") && isEventHappening && <TimeTableJoinNow event={event} />}
                        {event.Events[0] === "Planner" && (
                            <>
                                <div>
                                    {isHappened && <div style={{ cursor: "pointer", color: "#2E3A59" }}>Completed</div>}
                                    {/* {isEventHappening && <TimeTableJoinNow event={event} />} */}
                                    {isUpcoming && <Upcoming event={event} />}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div >
        </div >
    );
}

export default TimeTableDayEvent;
